import React, { PureComponent } from 'react';
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';

export default class RelativeDate extends PureComponent {
  render() {
    const timeAgo = distanceInWordsToNow(this.props.iso);
    return <span>{timeAgo} ago</span>;
  }
};



// WEBPACK FOOTER //
// ./src/components/RelativeDate.jsx